export const PC_CONTENT = {
  hero: {
    kicker: 'Para empresas que compram de fornecedores para revender ou produzir',
    title: 'Conferir nota de fornecedor na mão é perder tempo e ainda assim errar o estoque.',
    subtitle:
      'Importe o XML da NF-e do fornecedor direto no sistema, confirme o que realmente chegou e deixe o estoque e o financeiro se atualizarem sozinhos.',
    cta: 'Quero organizar minhas compras',
    ctaMessage: 'Quero conhecer o controle de compras do 77Gestão',
    urgency: 'Cada nota conferida na mão é tempo perdido que podia estar em outra parte do negócio.',
  },

  statsStrip: [
    { number: 'Importação', label: 'automática do XML da NF-e', icon: 'fa-solid fa-file-import' },
    { number: 'Zero', label: 'erro de dar entrada no que ainda não chegou', icon: 'fa-solid fa-triangle-exclamation' },
    { number: 'Automático', label: 'estoque e contas a pagar atualizados', icon: 'fa-solid fa-arrows-rotate' },
  ],

  pain: {
    title: 'Se comprar de fornecedor ainda dá esse trabalho todo, você não está sozinho',
    intro:
      'Empresas que compram para revender ou produzir perdem tempo e precisão quando a conferência de compras é feita manualmente.',
    items: [
      { icon: 'fa-solid fa-file-invoice', text: 'Nota fiscal do fornecedor conferida item por item, na mão, comparando com o pedido.' },
      { icon: 'fa-solid fa-truck-ramp-box', text: 'Mercadoria que chega antes de qualquer confirmação já entra no estoque — e depois não bate com a nota.' },
      { icon: 'fa-solid fa-boxes-stacked', text: 'Estoque desatualizado por dias até alguém lançar manualmente a compra no sistema.' },
      { icon: 'fa-solid fa-money-check-dollar', text: 'Contas a pagar lançadas separadamente, com risco de esquecer ou duplicar um fornecedor.' },
      { icon: 'fa-solid fa-magnifying-glass', text: 'Divergência entre o que foi pedido e o que realmente chegou só aparece depois, quando já é tarde.' },
    ],
  },

  midCta: {
    text: 'E se o XML do fornecedor já chegasse pronto no sistema, faltando só confirmar o que realmente recebeu?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do controle de compras do 77Gestão',
  },

  solution: {
    title: 'Da ordem de compra à entrada no estoque, sem conferência manual',
    intro:
      'O módulo de compras do 77Gestão foi pensado para quem compra de fornecedor com frequência e precisa de precisão sem perder tempo.',
    cards: [
      {
        icon: 'fa-solid fa-file-import',
        title: 'Importação de XML da NF-e',
        text: 'Importe a nota fiscal do fornecedor direto no sistema — sem digitar item por item manualmente.',
      },
      {
        icon: 'fa-solid fa-list-check',
        title: 'Ordens de compra',
        text: 'Registre o que foi pedido ao fornecedor e acompanhe até a chegada, sem depender de e-mail ou WhatsApp.',
      },
      {
        icon: 'fa-solid fa-clipboard-check',
        title: 'Confirmação separada da entrada',
        text: 'A entrada em estoque só acontece quando você confirma que a mercadoria realmente chegou — evita o erro de dar entrada em algo que ainda está a caminho.',
      },
      {
        icon: 'fa-solid fa-boxes-stacked',
        title: 'Estoque atualizado automaticamente',
        text: 'Ao confirmar a entrada, o estoque é atualizado na hora, sem lançamento manual separado.',
      },
      {
        icon: 'fa-solid fa-money-bill-wave',
        title: 'Contas a pagar geradas automaticamente',
        text: 'A confirmação da compra já gera o contas a pagar para o fornecedor, evitando esquecimento ou duplicidade.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a compra para de ser conferida na mão',
    intro:
      'Uma empresa que compra regularmente de fornecedores para revenda conferia cada nota fiscal manualmente e lançava estoque e financeiro em etapas separadas.',
    stats: [
      { number: '0', label: 'divergências entre pedido e entrega' },
      { number: '3x', label: 'mais rápido para dar entrada em uma compra' },
      { number: '100%', label: 'de estoque e financeiro atualizados juntos' },
    ],
    paragraphs: [
      'Depois da implantação acompanhada, a nota fiscal do fornecedor passou a ser importada direto por XML, eliminando a digitação manual item por item.',
      'A confirmação da entrega passou a ser um passo separado da ordem de compra — só depois de confirmar o que chegou, o estoque e o contas a pagar são atualizados automaticamente.',
    ],
    highlight: 'Resultado: conferência mais rápida, estoque sempre correto e nenhuma conta a pagar esquecida.',
    cta: 'Quero esse mesmo controle',
    ctaMessage: 'Vi o resultado e quero entender como organizar as compras da minha empresa no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares que mudam o controle de compras',
    items: [
      {
        icon: 'fa-solid fa-eye',
        title: 'Visibilidade',
        text: 'Você sabe o que foi pedido, o que já chegou e o que ainda está pendente com cada fornecedor.',
      },
      {
        icon: 'fa-solid fa-sliders',
        title: 'Controle',
        text: 'Nada entra no estoque sem confirmação — o erro de dar entrada em mercadoria que ainda não chegou desaparece.',
      },
      {
        icon: 'fa-solid fa-bolt',
        title: 'Agilidade',
        text: 'Importar o XML da nota do fornecedor elimina a digitação manual item por item.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para controlar as compras',
    items: [
      { icon: 'fa-solid fa-puzzle-piece', text: 'Fluxo de compra pensado para quem compra de fornecedor com frequência, não um cadastro genérico.' },
      { icon: 'fa-solid fa-link', text: 'Compras integradas com estoque e financeiro — a confirmação de entrada alimenta os dois automaticamente.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada para configurar o processo do jeito que sua empresa compra.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano, próximo e bem avaliado.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Preciso digitar a nota fiscal do fornecedor manualmente?',
        answer:
          'Não. Você importa o XML da NF-e do fornecedor direto no sistema, e os dados dos produtos e valores já vêm preenchidos.',
      },
      {
        question: 'Se a mercadoria ainda não chegou, ela já entra no estoque?',
        answer:
          'Não. A ordem de compra fica registrada separada da entrada em estoque — o estoque só é atualizado quando você confirma que o que pediu realmente chegou.',
      },
      {
        question: 'As contas a pagar do fornecedor são lançadas automaticamente?',
        answer:
          'Sim. Ao confirmar a entrada da compra, o sistema já gera automaticamente o contas a pagar correspondente, sem lançamento manual separado.',
      },
      {
        question: 'Funciona para empresas que compram de vários fornecedores diferentes?',
        answer:
          'Sim. Cada ordem de compra é vinculada ao fornecedor correspondente, com histórico próprio de pedidos e importações de nota.',
      },
      {
        question: 'É difícil encaixar esse processo na minha rotina de compras atual?',
        answer:
          'Não. A implantação é acompanhada e adapta o fluxo de ordens de compra e confirmação de entrada ao jeito que sua empresa já compra hoje.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de conferir nota fiscal de fornecedor na mão.',
    subtitle:
      'Agende uma demonstração e veja como importar o XML, confirmar entregas e manter estoque e financeiro sempre atualizados.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do controle de compras do 77Gestão',
  },

  seo: {
    title: 'Sistema de Controle de Compras com XML de NF-e | 77Gestão',
    description:
      'Sistema de controle de compras: importe o XML da NF-e do fornecedor, confirme a entrada em estoque separada da compra e atualize o financeiro automaticamente.',
  },
};
